import CollapseTemplate from '../../html/components/collapse.html'
import CollapseToggleTemplate from '../../html/components/collapse-toggle.html'
import CollapseGroupTemplate from '../../html/components/collapse-group.html'

import {inert} from '../shared/directives'
import Component from '../shared/component'
import Relation, {HasOne, HasMany, MemberOf} from '../shared/mixins/relation'

const collapseGroup = Relation({explicit: true})
const collapseToggle = Relation()

export const Collapse = Component('v-collapse', {
  mixins: [
    MemberOf(collapseToggle, 'toggle')
  ],
  template: CollapseTemplate,
  props: {
    expanded: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    active () {
      const {toggle} = this

      if (toggle) {
        return toggle.active
      }
    }
  }
})

export const CollapseToggle = Component('v-collapse-toggle', {
  mixins: [
    HasOne(collapseToggle, 'collapse'),
    MemberOf(collapseGroup, 'group')
  ],
  directives: {
    inert
  },
  template: CollapseToggleTemplate,
  data () {
    return {
      active: false
    }
  },
  computed: {
    target () {
      const {collapse} = this

      if (collapse) {
        return collapse.id
      }
    }
  },
  watch: {
    active: {
      immediate: true,
      handler () {
        this.$emit('change', this.active)

        if (this.active) {
          this.$emit('show')
        } else {
          this.$emit('hide')
        }
      }
    },

    collapse () {
      this.active = this.collapse.expanded
    }
  },
  methods: {
    toggle () {
      if (this.active) {
        this.hide()
      } else {
        this.show()
      }
    },

    show () {
      if (!this.active) {
        this.active = true
      }
    },

    hide () {
      if (this.active) {
        this.active = false
      }
    }
  }
})

export const CollapseGroup = Component('v-collapse-group', {
  mixins: [
    HasMany(collapseGroup, 'toggles')
  ],
  template: CollapseGroupTemplate,
  props: {
    multiselectable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      active: null
    }
  },
  watch: {
    active () {
      this.$emit('change', this.active)
    },

    toggles () {
      this.toggles.forEach(toggle => {
        toggle.$on('change', active => active
          ? this.show(toggle)
          : this.hide(toggle)
        )
      })
    }
  },
  methods: {
    show (toggle) {
      if (!this.multiselectable && this.active !== toggle) {
        if (this.active) {
          this.active.hide()
        }

        toggle.show()
        this.active = toggle
      }
    },

    hide (toggle) {
      if (!this.multiselectable && this.active === toggle) {
        toggle.hide()
        this.active = null
      }
    }
  }
})

export const CollapseToggleMixin = {
  props: {
    collapse: {
      type: Object,
      default: null
    }
  }
}
